/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpManagerService } from '../httpmanager.service';
@Injectable()
export class MobilecrashreportService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allMobilecrashreport(): Promise<any> {
        return this.httpmanagerService.HttpPost2('crashreport', "", "").then(data => {
            return data;
        })
    }
    deleteMobilecrashreport(): Promise<any> {
        return this.httpmanagerService.HttpPost2('crashreport/delete', "", "").then(data => {
            return data;
        })
    }
    createBackup(): Promise<any> {
        return this.httpmanagerService.HttpPost2('crashreport/createbackup', "", "").then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/mobilecrashreport/mobilecrashreport.service.ts